exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".first-time-track-animation__start-animation__1RYLB{position:relative;animation:first-time-track-animation__reveal-swipe-option__fc2EF 1.3s}@keyframes first-time-track-animation__reveal-swipe-option__fc2EF{0%,to{animation-timing-function:ease-out;left:0}85%{animation-timing-function:linear;left:-60px}}", ""]);

// exports
exports.locals = {
	"start-animation": "first-time-track-animation__start-animation__1RYLB",
	"startAnimation": "first-time-track-animation__start-animation__1RYLB",
	"reveal-swipe-option": "first-time-track-animation__reveal-swipe-option__fc2EF",
	"revealSwipeOption": "first-time-track-animation__reveal-swipe-option__fc2EF"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/first-time-track-animation/first-time-track-animation.styl
// module id = 2911
// module chunks = 1